import { FormattedMessage } from 'react-intl'

import SmallDarkLogo from 'app/assets/images/small-dark-logo.svg'
import Stack from 'app/components/base/Stack'
import Text from 'app/components/base/Text'

const PoweredByBlock = () => {
  return (
    <Stack
      direction="row"
      spacing={1}
      sx={{ justifyContent: 'flex-end', alignItems: 'center' }}
    >
      <Text variant="subtitle2">
        <FormattedMessage defaultMessage="Powered by" />
      </Text>

      <SmallDarkLogo />
    </Stack>
  )
}

export default PoweredByBlock
